<template>
  <centered-content>
    <v-progress-circular :size="50" color="primary" indeterminate />
  </centered-content>
</template>

<script>
import CenteredContent from '@/components/CenteredContent'
import { ROUTE_NAME as ROUTE_NAME_LOGIN_ADMIN } from '@/views/LoginAdmin'
import { ROUTE_NAME as ROUTE_NAME_LOGIN_USER } from '@/views/LoginUser'
import { mapMutations } from 'vuex'
import { SET_CHALLENGE, SET_LOGIN_TYPE } from '@/store'

export default {
  name: 'Home',
  components: {
    CenteredContent
  },
  computed: {
    challenge () {
      return this.$route.query.login_challenge
    }
  },
  methods: {
    ...mapMutations({
      setChallenge: SET_CHALLENGE,
      setLoginType: SET_LOGIN_TYPE
    }),
    async getLoginType () {
      const resp = await this.axios.get('/api/v1/login', {
        params: {
          login_challenge: this.challenge
        }
      })

      if (resp.headers.location) {
        window.location = resp.headers.location
        return
      }

      let nextRouteName
      switch (resp.data) {
        case 0: // admin
          nextRouteName = ROUTE_NAME_LOGIN_ADMIN
          break
        case 1: // user
          nextRouteName = ROUTE_NAME_LOGIN_USER
          break
        default:
          throw new Error(
            `unknown login response: ${JSON.stringify(resp, null, 2)}`
          )
      }

      this.setLoginType(resp.data)
      this.setChallenge(this.challenge)

      this.$router.push({
        name: nextRouteName
      })
    }
  },
  mounted () {
    this.getLoginType().catch(console.error)
  }
}
</script>
